"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3324 8.1401c-.64-.961-1.278-1.8298-1.7551-2.4573a53.022 53.022 0 0 0-.2941-.383 43.9383 43.9383 0 0 0-.2846-.3631c-.2364-.2983-.4781-.5922-.7198-.8862A143.402 143.402 0 0 1 12 3.711c-.0887.1084-.1777.2166-.2667.3248-.2457.2988-.4915.5977-.7319.901a47.9373 47.9373 0 0 0-.5787.7462c-.477.6274-1.1151 1.4962-1.755 2.4572-.6377.9576-1.2898 2.0257-1.7862 3.0491C6.4018 12.1783 6 13.2586 6 14.1989c0 3.3352 2.6808 6.0909 6 6.0909s6-2.7557 6-6.0909c0-.9403-.4018-2.0206-.8815-3.0097-.4964-1.0234-1.1485-2.0915-1.7861-3.049zM12 6.9128c-.4587.6039-1.0641 1.4294-1.6676 2.3358-.6124.9197-1.2103 1.9039-1.6514 2.8134-.457.9423-.681 1.6763-.681 2.1369 0 2.2665 1.8209 4.0909 4 4.0909s4-1.8244 4-4.0909c0-.4606-.224-1.1946-.681-2.1369-.4411-.9095-1.039-1.8937-1.6514-2.8134-.6035-.9064-1.2089-1.732-1.6676-2.3358z"
  })];
};

exports.default = _default;